import React, { Component } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import autobind from 'react-autobind';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import Page404 from './components/Page404';
import { Login, Register, Welcome, ForgotPassword, Home, Market, MyPage, Board, BoardDetail, Details, Withdrawal } from './screens';
import AppLayout from './components/Layout/AppLayout'
import UserLayout from './components/Layout/UserLayout'

import './locales/index'
import '@fortawesome/fontawesome-free/js/all.js'
import './assets/css/common.scss';


const routes = [
  { path : '/home', content : <Home /> },
  { path : '/market', content : <Market /> },
  { path : '/mypage', content : <MyPage /> },
  { path : '/news', content : <Board /> },
  { path : '/board/:type/:id', content : <BoardDetail /> },
  { path : '/details', content : <Details /> },
  { path : '/withdrawal', content : <Withdrawal /> },
  
]
const userroutes = [
  { path : '/welcome', content : <Welcome /> },
  { path : '/', content : <Welcome /> },
  { path : '/login', content : <Login /> },
  { path : '/register', content : <Register /> },
  { path : '/forgotpassword', content : <ForgotPassword /> },
]

export default class App extends Component {
  constructor(props) {
    super(props);
    autobind(this);

    this._routes = null;
  }
  
  render() {
    return (
      <Provider store={configureStore()}>
        <BrowserRouter>

          <Routes>
              {routes.map((item, i) => (
              <Route key={i} path= {item.path} element={ <AppLayout>{item.content}</AppLayout>} />
              ))}
              {userroutes.map((item, i) => (      
                 <Route key={i} path= {item.path}  element = {<UserLayout> {item.content}</UserLayout>}/>
               ))
             }
              <Route component={Page404} />
          </Routes>
         </BrowserRouter>
      </Provider>
    );
  }
}